module.exports = __webpack_public_path__ + "static/media/400083_02.5ec47680.png";